import styled from '@emotion/styled'

export const SendEmailInvoiceFormWrapper = styled.div`
  position: relative;
`
